/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Conflict resolution request
 * @export
 * @interface ConflictResolutionRequest
 */
export interface ConflictResolutionRequest {
    /**
     * 
     * @type {string}
     * @memberof ConflictResolutionRequest
     */
    strategy?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ConflictResolutionRequest
     */
    resolvedData?: { [key: string]: any; };
}

/**
 * Check if a given object implements the ConflictResolutionRequest interface.
 */
export function instanceOfConflictResolutionRequest(value: object): value is ConflictResolutionRequest {
    return true;
}

export function ConflictResolutionRequestFromJSON(json: any): ConflictResolutionRequest {
    return ConflictResolutionRequestFromJSONTyped(json, false);
}

export function ConflictResolutionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConflictResolutionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'strategy': json['strategy'] == null ? undefined : json['strategy'],
        'resolvedData': json['resolvedData'] == null ? undefined : json['resolvedData'],
    };
}

export function ConflictResolutionRequestToJSON(json: any): ConflictResolutionRequest {
    return ConflictResolutionRequestToJSONTyped(json, false);
}

export function ConflictResolutionRequestToJSONTyped(value?: ConflictResolutionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'strategy': value['strategy'],
        'resolvedData': value['resolvedData'],
    };
}

